import { useContext } from "react";
import { WidgetNavigationContext } from "../contexts/widget-navigation";

export const useWidgetNavigation = () => {
  const context = useContext(WidgetNavigationContext);
  if (!context) {
    throw new Error(
      "useWidgetNavigation must be used within a WidgetNavigationProvider",
    );
  }
  return context;
};
